var React = require('react');

function CloseCross (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"19","cy":"19","r":"19","fill":"#D3D3D3","key":0}),React.createElement("path",{"d":"M12.7088 12.2642L25.4367 24.9921","stroke":"#F9F9F9","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M25.4367 12.2642L12.7088 24.9921","stroke":"#F9F9F9","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CloseCross.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = CloseCross;

CloseCross.default = CloseCross;
